import { LineLayer } from "mapbox-gl";

const HullStrokeLayerHovered: LineLayer = {
  id: "hull-stroke-layer-hovered",
  type: "line",
  paint: {
    "line-color": "gold",
    "line-width": 2
  }
}

export { HullStrokeLayerHovered }
